import Menu from "pages/menuMain/menu";
import React from "react";
import { useSelector } from "react-redux";

import CollectpointHeader from "../centerComponent/collectPointHeader";
import LuckydrawContent from "./components/LuckydrawContent";
import LoadingSpinner from "./components/LoadingSpinner";
import ErrorMessage from "./components/ErrorMessage";
import LuckydrawSEO from "./components/LuckydrawSEO";
import { useLuckydraw } from "./hooks/useLuckydraw";
import { usePagination } from "./hooks/usePagination";

const DEF_LIMIT = 10;
const DEF_OFFSET = 0;

const Luckydraw = () => {
  const stateProfile = useSelector((state) => state.profile.dataUser);

  // Custom hooks
  const { limit, offset, goToNext, goToBack } = usePagination(DEF_LIMIT, DEF_OFFSET);
  const { luckydraws, rowCount, isLoading, error, refetch } = useLuckydraw(limit, offset);

  // Debug log
  console.log("currentPoint ", stateProfile.currentPoint);

  const renderContent = () => {
    if (isLoading) {
      return <LoadingSpinner />;
    }

    if (error) {
      return <ErrorMessage message={error} onRetry={refetch} />;
    }

    return <LuckydrawContent luckydraws={luckydraws} limit={limit} offset={offset} rowCount={rowCount} onBack={goToBack} onNext={goToNext} />;
  };

  return (
    <div>
      <LuckydrawSEO />

      <div id="pageLuckydraw-All">
        <main>
          <div className="wrapContent">
            <CollectpointHeader />
            {renderContent()}
            <Menu />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Luckydraw;
